import { UIHeading5 } from '@cian/ui-kit';
import { IconActionPlan16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './LayoutButton.css';

interface ILayoutButtonProps {
  onClick(): void;
}

export const LayoutButton: React.FC<ILayoutButtonProps> = ({ onClick }) => {
  return (
    <button onClick={onClick} className={styles['container']}>
      <IconActionPlan16 color="icon-on-bright-default" />
      <UIHeading5 color="text-on-bright-default">Планировка</UIHeading5>
    </button>
  );
};
